
import appConfigModule from "../store/plugins/appConfig";
import { Vue, Component } from "vue-property-decorator";

@Component
export default class layoutLogin extends Vue {
  appConfig: any = appConfigModule;
}
